import React, { useEffect, useState } from "react";
import UpdatePassword from "../UpdatePassword";
import UserUpdatedata from "./UserUpdatedata";

function UserLogD({ ...props }) {
    const [UData, setUData] = useState([]);
    const [updatestate, setupdatestate] = useState(0);
    const getdata = async () => {
        const sendData = {
            OrgId: Number(1),
            CatgTypeId: Number(props.catgTypeId)
        }

        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetDetailsuser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setUData(data)
                })


    };



    useEffect(() => {
        getdata()
    }, [props.catgTypeId, updatestate])

   
   

    return (
        <>
            <td>{UData.loginName}</td>
            <td>EEX@123</td>
            <td>{UData.phoneNo}</td>
            <td>{UData.emailId}</td>
            <td><UserUpdatedata userId={UData.userId} catgTypeId={props.catgTypeId} updatestate={updatestate} setupdatestate={setupdatestate} /></td>
            <td><UpdatePassword userId={UData.userId} /></td>
        </>
    );
};

export default UserLogD;
